import api from './index';

let exports = {};
// 获取交易单列表
exports.getTradeVoucherList = function (params, callback) {// 获取交易单列表
    api.post('/trade/voucher/list/get')
    .data(params)
    .done(callback)
    .go();
};
// 获取交易数据列表
exports.getTradeVoucherDtoList = function (data, callback) {// 获取交数据单列表
    api.post('/trade/voucher/dto/list/get')
    .data(data)
    .done(callback)
    .go();
};
// 交易数据核对-导出url
exports.getTradeVoucherDtoListExportUrl = function (data, callback) {
    api.post('/trade/voucher/dto/list/export/url/get')
    .data(data)
    .done(callback)
    .go();
};
// 根据交易单id，阶段id（阶段id根据需要可不传）获取交易数据信息
exports.getTradeVoucherDtoPhaseInfo = function (data, callback) {// 根据交易单id，阶段id（阶段id根据需要可不传）获取交易数据信息
    api.post('/trade/voucher/dto/phase/info/get')
    .data(data)
    .done(callback)
    .go();
};

//获取交易单
exports.getTradeVoucherInfo = function (params, callback) {// 获取交易单信息
    api.get('/trade/voucher/info/get')
    .params(params)
    .done(callback)
    .go()
};
// 根据工单生成交易单
exports.saveTradeVoucherBySettleProof = function (data, callback) {// 根据结算凭据生成交易单
    api.post('/trade/voucher/save/do/by/settleProof')
    .data(data)
    .done(callback)
    .go();
};
exports.finishTradeVoucherInvoice = function (params, callback) {// 交易单发票开具完成操作
    api.post('/trade/voucher/invoice/finish/do')
    .params(params)
    .done(callback)
    .go();
};
// 交付完成操作
exports.finishTradeVoucherDeliver = function (params, callback) {// 交付完成操作
    api.post('/trade/voucher/deliver/finish/do')
    .params(params)
    .done(callback)
    .go();
};
// 验收完成操作
exports.fishihTradeVoucherCheck = function (params, callback) {// 验收完成操作
    api.post('/trade/voucher/check/finish/do')
    .params(params)
    .done(callback)
    .go();
};
exports.closeTradeVoucher = function (params, callback) {// 交易单关闭操作
    api.post('/trade/voucher/close/do')
    .params(params)
    .done(callback)
    .go();
};

//根据合同编号获取交易单
exports.getTradeVoucherByContractNo = function (params, callback) {// 根据合同编号获取交易单信息
    api.get('/trade/voucher/by/contractNo')
    .params(params)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/trade.js
// module id = 75
// module chunks = 0